/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>
/// <reference path="../../../services/internationalization/internationalization_data_dictionary.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CreateEmployeeModalController {
        public static $inject : string[] = [
            '$mdMedia',
            '$mdDialog',
            'DealerwareEmployeeModel',
            '$dealerwareInternationalizationData'
        ];

        public locationId: number;
        public onCreateSuccess: any;
        public labels: { generic?: string };

        constructor(public $mdMedia: any,
                    public $mdDialog: any,
                    public DealerwareEmployeeModel: any,
                    public $dealerwareInternationalizationData: DealerwareWebServices.DealerwareInternationalizationData) {
                        this.getLabels('errorMessages');
                    }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then(function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function() {}
            );
        }

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public showModal() {
            var _self = this;

            this.$mdDialog.show({
                controller: DialogController,
                templateUrl: '/components/employee/create/create_employee_modal_directive.html',
                locals: {
                    employee: new this.DealerwareEmployeeModel(),
                    locationId: this.locationId,
                    successCallback: this.onCreateSuccess
                },
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen
            });

            function DialogController($scope: any,
                                      $mdDialog: any,
                                      $dealerwareNotification: any,
                                      DataUtils: any,
                                      employee: any,
                                      locationId: any,
                                      successCallback: any) {
                $scope.dataUtils = DataUtils.getInstance();
                $scope.employee = employee;
                $scope.saving = false;

                var resolveEmployeeCreate = (employee: any) => {
                    $scope.saving = false;
                    $scope.closeDialog();
                    if (successCallback && angular.isFunction(successCallback)) {
                        successCallback({employee: employee});
                    }
                };

                $scope.createEmployee = () => {
                    $scope.saving = true;
                    $scope.employee.$save({
                        promise: true,
                        params: {
                            location_id: locationId,
                            include_user_profile: true
                        }
                    }).then(
                        (employee: any) => { resolveEmployeeCreate(employee); },
                        (response: any) => {
                            if (response.status === 422 && /email.*already.*taken/i.test(_self.labels.generic)) {
                                $scope.handleEmployeeConflict();
                            } else {
                                $scope.handleApiError(response);
                            }
                        }
                    );
                }

                $scope.enrollEmployee = () => {
                    $scope.employee.$enroll({
                        promise: true,
                        params: {
                            location_id: locationId,
                            include_user_profile: true
                        }
                    }).then(
                        (employee: any) => { resolveEmployeeCreate(employee); },
                        (response: any) => { $scope.handleApiError(response); }
                    );
                }

                $scope.handleApiError = (response: any) => {
                    $scope.saving = false;
                    $dealerwareNotification.apiError(response, undefined, { multiple: true });
                }

                $scope.handleEmployeeConflict = () => {
                    $mdDialog.show($mdDialog.confirm()
                        .title('Employee Already Exists')
                        .textContent('This employee already exists.  Would you like to give them Employee permissions at this location?')
                        .ariaLabel('Employee Already Exists')
                        .ok('Yes')
                        .cancel('Cancel')
                        .multiple(true)
                    ).then(
                        () => { $scope.enrollEmployee(); },
                        () => { $scope.saving = false; }
                    );
                }

                $scope.closeDialog = () => {
                    $mdDialog.hide();
                }
            }
        }
    }

    getDealerwareWebComponentsModule().controller('CreateEmployeeModalController', CreateEmployeeModalController);


    export class CreateEmployeeModalDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public controller       : any       =   'CreateEmployeeModalController';
        public controllerAs     : string    =   'createEmployeeModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            locationId: '=',
            onCreateSuccess: '&'
        };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                ctrls.showModal();
            });
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCreateEmployeeModal",() => new CreateEmployeeModalDirective());

}